export const payrollTeamEmail = "payroll@heartpayroll.com"
export const onboardingTeamEmail = "hello@heartpayroll.com"
export const facebook = "https://www.facebook.com/HeartPayroll/"
export const phone = "1-877-795-1164"
export const twitter = "https://www.twitter.com/HeartPayroll/"
